function setVh() {
	const vh = window.innerHeight * 0.01
	document.documentElement.style.setProperty('--vh', `${vh}px`)
}

export function setupVhListener() {
	setVh()
	window.addEventListener('resize', setVh)
}
